var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlasmaGrenade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M79.993 30.2641C79.993 41.7451 70.6855 51.0526 59.2045 51.0526C47.7235 51.0526 38.416 41.7451 38.416 30.2641C38.416 18.7831 47.7235 9.47559 59.2045 9.47559C64.42 9.47559 69.187 11.3956 72.8365 14.5696C77.221 18.3811 79.993 24.0001 79.993 30.2656V30.2641Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4681 15.1649C63.7331 15.1649 64.7586 14.5014 64.7586 13.6829C64.7586 12.8644 63.7331 12.2009 62.4681 12.2009C61.2031 12.2009 60.1776 12.8644 60.1776 13.6829C60.1776 14.5014 61.2031 15.1649 62.4681 15.1649Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7812 20.6895L50.7452 21.633",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9596 26.2815L50.7461 30.9975",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1442 24.1259L42.9307 28.0604",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5801 35.376L59.6246 37.263",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.457 34.8374L76.348 35.8469",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6271 34.8374L78.4356 32.6909",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2227 37.2629L77.6277 38.0039",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9021 38.0039L74.8641 40.0244",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3535 46.761L52.5655 48.783",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.424 44.4703L44.1445 42.6523",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0907 20.3024L45.9712 14.2319",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3347 34.8374C44.4407 34.8374 44.5267 34.7515 44.5267 34.6454C44.5267 34.5394 44.4407 34.4534 44.3347 34.4534C44.2287 34.4534 44.1427 34.5394 44.1427 34.6454C44.1427 34.7515 44.2287 34.8374 44.3347 34.8374Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.527 40.4084C44.633 40.4084 44.719 40.3225 44.719 40.2164C44.719 40.1104 44.633 40.0244 44.527 40.0244C44.4209 40.0244 44.335 40.1104 44.335 40.2164C44.335 40.3225 44.4209 40.4084 44.527 40.4084Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7818 36.039C47.8879 36.039 47.9738 35.9531 47.9738 35.847C47.9738 35.741 47.8879 35.655 47.7818 35.655C47.6758 35.655 47.5898 35.741 47.5898 35.847C47.5898 35.9531 47.6758 36.039 47.7818 36.039Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9732 42.114C48.0793 42.114 48.1652 42.028 48.1652 41.922C48.1652 41.8159 48.0793 41.73 47.9732 41.73C47.8672 41.73 47.7812 41.8159 47.7812 41.922C47.7812 42.028 47.8672 42.114 47.9732 42.114Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.993 30.2641C79.993 41.7451 70.6855 51.0526 59.2045 51.0526C47.7235 51.0526 38.416 41.7451 38.416 30.2641C38.416 18.7831 47.7235 9.47559 59.2045 9.47559C64.42 9.47559 69.187 11.3956 72.8365 14.5696C77.221 18.3811 79.993 24.0001 79.993 30.2656V30.2641Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8361 14.5681C72.8361 14.5681 68.5071 16.2271 65.5656 20.6896C62.9601 24.6421 63.1911 26.0926 63.1476 27.1576C63.0861 28.6561 62.8716 29.7181 61.6581 30.9301C60.4461 32.1421 56.5701 34.2556 56.1336 34.8376C56.1336 34.8376 55.0701 38.4751 55.1901 40.6321C55.4226 44.8096 56.8071 47.1001 56.8071 47.1001L61.9266 49.3906L62.3601 50.8156",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.18 50.6626C55.18 50.6626 54.1135 47.0986 53.17 46.4251C52.2265 45.7516 50.7445 45.0781 50.341 43.7296C49.9375 42.3811 49.903 34.7356 50.5765 33.9271L52.555 31.7371C53.5375 30.7261 54.517 25.9426 54.517 25.9426C54.517 25.9426 53.152 21.2266 52.555 20.0146C51.958 18.8026 50.3095 18.1276 48.7075 18.2626C47.1055 18.3976 44.1415 20.9581 43.333 22.0351C42.5245 23.1121 41.1775 27.5596 41.1775 28.9066C41.1775 30.2536 42.3895 31.8916 42.5245 32.6896C42.6595 33.4876 42.7945 38.6086 42.7945 38.6086L42.4495 42.5716",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6785 23.1736C53.6785 23.1736 58.8295 17.9941 62.1985 19.3411L65.5675 20.6881",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2725 30.9976C53.2725 30.9976 55.923 33.3526 57.579 33.5566",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9104 28.4026C79.9104 28.4026 76.3344 26.0776 72.8364 33.5566C69.3384 41.0356 71.6049 46.1401 73.3014 45.5416",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasmaGrenade);
export default __webpack_public_path__ + "static/media/Plasma Grenade.3d91b84d013760cd2cd53ebc875ba4b5.svg";
export { ForwardRef as ReactComponent };